import CustomInputCheckbox from "@/components/desktop/form/input/input-checkbox/CustomInputCheckbox";

const EstatesDaysSelector = ({ notificationDays, setNotificationDays, days }) => {
	const options = (days || []).map((day) => ({ value: day.id, label: day.name }));
	const value = (notificationDays || []).map(String);

	const handleChange = (newValue) => {
		setNotificationDays(newValue);
	};

	return <CustomInputCheckbox label="Dia de Notificación" options={options} value={value} onChange={handleChange} direction="horizontal" />;
};

export default EstatesDaysSelector;
